/** Site footer for the lorebook pages (not the map screen, which stays clean
 *  for the jam). Carries ownership + the workshop links. */
export function SiteFooter() {
  const year = new Date().getFullYear()
  return (
    <footer className="mt-auto border-t border-edge">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-4 pb-8 pt-16 sm:flex-row sm:items-start sm:justify-between lg:px-6">
        <div className="max-w-sm">
          <div className="font-display text-base text-white">System 404: Signal Lost</div>
          <p className="mt-1 text-xs leading-relaxed text-slate-500">
            An interactive lorebook. World, writing, and build &copy; {year} Steaked.
            An original setting, not affiliated with any existing property.
          </p>
        </div>

        <div className="flex flex-col gap-4 sm:flex-row sm:gap-10">
          <div>
            <div className="mb-2 text-[10px] font-medium uppercase tracking-[0.28em] text-slate-600">
              Explore
            </div>
            <ul className="flex flex-col gap-1.5 text-sm">
              <li>
                <a href="/" className="text-slate-400 transition hover:text-signal">
                  The Map
                </a>
              </li>
              <li>
                <a href="/lorebook" className="text-slate-400 transition hover:text-signal">
                  Lorebook
                </a>
              </li>
              <li>
                <a href="/characters" className="text-slate-400 transition hover:text-signal">
                  Characters
                </a>
              </li>
              <li>
                <a href="/export" className="text-slate-400 transition hover:text-signal">
                  Export the lore
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="mb-2 text-[10px] font-medium uppercase tracking-[0.28em] text-slate-600">
              The Workshop
            </div>
            <ul className="flex flex-col gap-1.5 text-sm">
              <li>
                <a
                  href="https://discord.gg/fPBJrsBPM5"
                  target="_blank"
                  rel="noreferrer"
                  className="text-slate-400 transition hover:text-signal"
                >
                  Discord
                </a>
              </li>
              <li>
                <a
                  href="https://theworkshop.team"
                  target="_blank"
                  rel="noreferrer"
                  className="text-slate-400 transition hover:text-signal"
                >
                  Voting site
                </a>
              </li>
              <li>
                <a
                  href="https://tools.theworkshop.team"
                  target="_blank"
                  rel="noreferrer"
                  className="text-slate-400 transition hover:text-signal"
                >
                  Tools
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="mb-2 text-[10px] font-medium uppercase tracking-[0.28em] text-slate-600">
              Profiles
            </div>
            <ul className="flex flex-col gap-1.5 text-sm">
              <li>
                <a
                  href="https://chub.ai/users/SteakedGamer"
                  target="_blank"
                  rel="noreferrer"
                  className="text-slate-400 transition hover:text-signal"
                >
                  Chub.ai
                </a>
              </li>
              <li>
                <a
                  href="https://app.wyvern.chat/profiles/SteakedGamer"
                  target="_blank"
                  rel="noreferrer"
                  className="text-slate-400 transition hover:text-signal"
                >
                  Wyvern Chat
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}
